import * as yup from "yup";
import { RiskRating } from "~/graphql/supergraphEnums";

export const getPaymentInstructionSchema = (showBankAndCountry: boolean) =>
  yup.object().shape({
    accountHolderId: yup
      .number()
      .required("Account holder required")
      .moreThan(-1, "Account holder required"),
    bankName: showBankAndCountry
      ? yup.string().required("Bank name required")
      : yup.string().optional(),
    country: showBankAndCountry
      ? yup.string().required("Country required")
      : yup.string().optional(),
    accountNameMatches: yup.string().oneOf(["yes", "no"]).required("Please select an option"),
    bankAccountName: yup.string().when("accountNameMatches", {
      is: "no",
      then: (schema) => schema.required("Bank account name required"),
    }),
    explanation: yup.string().when("accountNameMatches", {
      is: "no",
      then: (schema) => schema.required("Explanation required"),
    }),
    riskRating: yup.mixed<RiskRating>().nullable().default(null),
  });
